export const profile = {
  name: "Sagnik Pal",
  role: "Frontend Engineer",
  location: "Kolkata, India",
  email: "palsagnik2001@gmail.com",
  phone: "+91 90380 21491",
  github: "https://github.com/sagnik2001",
  linkedin: "https://linkedin.com/in/sagnik-pal-4437b2209",
  medium: "https://medium.com/@palsagnik2001",
  leetcode: "https://leetcode.com/u/Sagnik_09/",
  website: "https://sagnik-2001.vercel.app",
};

export const heroStats = [
  { value: "2+", label: "years shipping production web and mobile" },
  { value: "97", label: "mobile Lighthouse score on a live storefront" },
  { value: "99.2%", label: "crash-free sessions in production" },
  { value: "15%", label: "conversion lift from features I shipped" },
];

export const impactHighlights = [
  "Rebuilt a high-traffic storefront for speed — pages now load in under a second, with almost no layout shift.",
  "Modernised a production React Native app used by thousands of shoppers, making it noticeably faster to open and smoother to use.",
  "Reworked the checkout experience end to end, lifting UPI payment conversion from 20% to 30%.",
  "Built the billing and inventory platform that now runs 14 physical retail stores, replacing paid third-party software.",
];

export const experiences = [
  {
    role: "SDE - Frontend & React Native",
    company: "NEWME Asia",
    meta: "Fashion e-commerce · Full-time",
    period: "Sep 2024 - Present",
    stack: "React Native · Next.js · SvelteKit · TypeScript · Vite · TanStack Query · AWS · Jest · Playwright",
    bullets: [
      "Modernised the React Native app's core rendering stack, improving cold start by 13% and reducing cart render latency.",
      "Drove web performance: PDP Lighthouse 48 to 83, shop page load down 60%, and a live SvelteKit storefront scoring 97 / 94 / 100 / 100 on mobile.",
      "Rebuilt payment flows with full funnel instrumentation; checkout-to-order improved 5-14 pp and UPI conversion moved from 20% to 30%.",
      "Shipped image search, Black Friday, and Next Day Delivery modules, contributing to a 15% conversion lift.",
      "Migrated hosting from AWS Amplify to EC2 and CloudFront, cutting latency 20% and hosting cost 30%.",
      "Designed POS billing and inventory tooling with 90%+ critical-path test coverage and zero billing failures since rollout.",
    ],
  },
  {
    role: "SDE - Frontend",
    company: "Yukin AI",
    meta: "AI / SaaS · Full-time",
    period: "Jan 2024 - Sep 2024",
    stack: "Astro.js · PWA · Firebase · REST APIs · Jest",
    bullets: [
      "Rebuilt the product frontend in Astro.js, cutting page load from 5s to 2s and first paint from 3s to 1s.",
      "Shipped an offline-capable PWA with push notifications, growing daily active users 10% and retention 12%.",
      "Built a Firebase notification dashboard, REST APIs, and chatbot automation that sped up the team's delivery by 30%.",
      "Added Jest unit and integration coverage across critical workflows and mentored junior engineers on performance practices.",
    ],
  },
];

export const skills = [
  "React",
  "React Native",
  "Next.js",
  "SvelteKit",
  "Astro.js",
  "TypeScript",
  "TanStack Query",
  "Core Web Vitals",
  "Lighthouse",
  "Payments & Checkout",
  "Analytics Instrumentation",
  "Firebase",
  "MongoDB",
  "MySQL",
  "Jest",
  "Playwright",
  "Detox",
  "AWS EC2 / S3 / CloudFront",
  "CI/CD",
  "Sentry",
];

export const projects = [
  {
    title: "Podcast & Audiobook Player",
    type: "React Native · MMKV · WatermelonDB",
    description:
      "An offline-first audio player my family uses every day. Episodes download once, playback keeps running on the lock screen or during app switches, and every listen resumes from the exact second it left off.",
    impact: [
      "Background playback and lock-screen controls on iOS and Android.",
      "A persistent local library with saved playback positions and offline episodes.",
      "Tuned for native performance on modern React Native internals.",
    ],
    link: "https://github.com/sagnik2001/Podecast-AudioPlayer/releases/tag/v1.0.0",
  },
  {
    title: "Clinic Click / PregaBuddy",
    type: "React · Express · MongoDB · Firebase",
    description:
      "Built for Mamta HMIC, a local NGO — health workers register patients, log checkups, track appointments, and send mothers week-by-week milestone updates.",
    impact: [
      "Presented to NGO stakeholders and used in demonstrations and funding discussions.",
      "Owned the React frontend, Express/MongoDB API, Firebase auth, and deployment.",
      "Shaped iteratively from direct feedback by staff using it in the field.",
    ],
    link: "https://prega-tracker.vercel.app/",
  },
  {
    title: "In-House POS & Inventory Platform",
    type: "React · TypeScript · Vite · TanStack Query",
    description:
      "The billing and inventory system behind 14 physical NEWME stores — offline billing, invoicing, SKU tracking, stock reconciliation, and role-based admin workflows.",
    impact: [
      "Replaced third-party store software, removing its recurring licence cost.",
      "91% automated test coverage across critical paths.",
      "Zero billing failures in production since rollout.",
    ],
    link: profile.github,
  },
];

export const education = {
  degree: "B.Tech CSE",
  school: "University of Engineering and Management, Kolkata",
  period: "2020 - 2024",
  cgpa: "8.84 / 10",
};

export const achievements = [
  "Top 22% global LeetCode contest ranking.",
  "Rank 2,785 / 19,437 in LeetCode Biweekly.",
  "Open source contributor — GSSoC.",
];
